<template>
    <div>
        <div class="container-md ">
            <div class="row">
                <div class="col-6">
                    <h3 class="text-uppercase">Itemgroup music</h3>

                </div>
                <div class="col-6">
                    <i class="fa fa-pencil float-right pl-3" style="font-size: 24px; cursor: pointer"
                       aria-hidden="true" data-toggle="modal" data-target="#newItemgroup" v-on:click="editCommittee"></i>
                    <i class="fa fa-plus float-right " data-toggle="modal" data-target="#newItemgroup"
                       style="font-size: 24px;cursor: pointer" v-on:click="newCommittee"></i>
                    <i class="fa fa-trash float-right pr-3" style="font-size: 24px; cursor: pointer" data-toggle="modal"
                       data-target="#deleteModal" aria-hidden="true"></i>


                </div>

            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-6 mt-3  ">
                    <div class="container-bg p-3" style="height: 283px;">
                        <div class="card ">
                            <div class="row no-gutters align-items-center pt-3 p-2" style="border-radius: 20px;">
                                <div class="col-md-3 col-12 text-sm-center">
                                    <img :src="'/assets/img/blank-profile-picture-973460_640.png'"
                                         style="width: 80px;height: 80px;border: 1px solid #FFFFFF;border-radius: 50%"
                                         class="img-fluid" alt="">
                                </div>
                                <div class="col-md-9 col-12 ">
                                    <div class="card-block px-2">
                                        <h3 class="text-white text-uppercase">Muzikanten</h3>
                                        <p class="text-white" style="line-height: normal">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer w-100 ">
                                <div class="row  align-items-center">
                                    <div class="col-6 ml-2">
                                        <div >
                                            <img :src="'/assets/img/blank-profile-picture-973460_640.png'"
                                                 style="height: 35px;width: 35px;margin-left: -8px;border:1px solid #FFFFFF;border-radius: 50%"
                                                 alt="">
                                        </div>



                                    </div>
                                    <div class="col-5">
                                        <button class="btn btn-dark text-white">See more</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mt-3">
                    <div class="container-bg p-3 custom-scrollbar" style="height: 283px;">
                        <h3 class="text-center text-uppercase">itemgroups <i class="fa fa-plus ml-3 "
                                                                             data-toggle="modal"
                                                                             data-target="#itemgroupsModal"
                                                                             style="font-size: 24px;cursor: pointer"></i>
                        </h3>


                        <div class="flex-container flex-body p-2">
                            <div class="item" style="flex: 0">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 50px;width: 50px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                            </div>
                            <div class="item text-white">
                                <p style="margin: 0">Music</p>
                            </div>
                            <div class="item">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                                <img src="./../../../assets/images/adult-1851571_1920.png"
                                     style="height: 35px;width: 35px;margin-left: -8px;margin-top:-8px;border:1px solid #FFFFFF;border-radius: 50%"
                                     alt="">
                            </div>
                            <div class="item text-white">
                                <img src="/assets/img/bell(1).svg"
                                     alt="" class="m-1" style="height: 20px">
                                <img src="/assets/img/doc.svg"
                                     alt="" class="m-1" style="height: 20px">
                                <img src="/assets/img/Conversation.svg"
                                     alt="" class="m-1" style="height: 20px">
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-12 mt-3">
                    <div class=" container-bg p-4">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="text-uppercase">Items</h3>
                            </div>

                        </div>
                        <div class="row mt-4">
                            <div class="col-md-4">

                                    <div class="form-group" style=" margin-left: 85px;">
                                        <select class="form-control" id="exampleFormControlSelect1" style="background-color: #292929; color: white;">
                                            <option>Item Name</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                        </select>
                                    </div>

                            </div>
                            <div class="col-md-5 col-12">
                                <div class="float-right">
                                    <input class="search-box" type="text" placeholder="Zoeken">
                                    <button class="search-btn" ><img
                                            src="/assets/img/search.svg" alt="Search"
                                            style="margin-bottom: 4px"></button>
                                </div>
                            </div>
                            <div class="col-md-2" >
                                <button class="btn btn-dark">Export</button>
                            </div>
                            <div class="col-md-1" style="margin-left: -21px;margin-top: 5px;">
                                <i class="fa fa-plus float-right mt-1" data-toggle="modal" data-target="#newItemgroup"
                                   style="font-size: 24px;cursor: pointer"></i>
                            </div>
                        </div>


                        <div class="flex-container flex-body mt-3" data-toggle="collapse" data-target="#next" style="cursor:pointer;">
                            <div class="item text-center" style="flex: 2.2">
                                <img    src="/assets/img/star.svg"
                                        alt=""
                                >
                            </div>
                            <div class="item text-white" style="flex: 3.2">We will rock you</div>
                            <div class="item text-white" style="flex: 7.1;text-align: right;margin-right: 10%;"> Rock > Genre > Music</div>

                            <div class="item text-white" style="flex: 2">
                                <a class="text-white" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                                <a class="text-white" style="margin-right:10px"><i class="fa fa-plus" aria-hidden="true" data-toggle="modal" data-target="#addfileModal"></i></a>
                                <a class="text-white" style="margin-right:10px"><i class="fa fa-pencil"></i></a>
                                <a class="text-white"><i class="fa fa-lock" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <div id="next" class="collapse" style="margin-top: 18px; width: 92%; margin-left: 35px;">
                            <div class="row" style="background-color: white; height: 80px;padding-top: 25px; padding-left: 40px;">

                                <div class="col-lg-6 col-md-12 col-12">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-3 col-3">
                                            <img src="/assets/img/Docicon.svg" alt="" >
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-6">
                                            <span>Document title lorem</span>
                                        </div>
                                        <div class="col-lg-4 col-md-3 col-3">
                                            <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                                            <a class=""><i class="fa fa-pencil"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-3 col-3">
                                            <img src="/assets/img/Docicon.svg" alt="" >
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-6">
                                            <span>Document title lorem</span>
                                        </div>
                                        <div class="col-lg-4 col-md-3 col-3">
                                            <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                                            <a class=""><i class="fa fa-pencil"></i></a>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div class="row" style="background-color: white; height: 80px; padding-top: 25px; padding-left: 40px;">

                                <div class="col-lg-6 col-md-12 col-12">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-3 col-3">
                                            <img src="/assets/img/Docicon.svg" alt="" >
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-6">
                                            <span>Document title lorem</span>
                                        </div>
                                        <div class="col-lg-4 col-md-3 col-3">
                                            <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#"></i></a>
                                            <a class=""><i class="fa fa-pencil"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12 col-12">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-3 col-3">
                                            <img src="/assets/img/Docicon.svg" alt="" >
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-6">
                                            <span>Document title lorem</span>
                                        </div>
                                        <div class="col-lg-4 col-md-3 col-3">
                                            <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#"></i></a>
                                            <a class=""><i class="fa fa-pencil"></i></a>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!--<div class=" container-bg p-5 ">
                <div class="row">
                    <div class="col-6">
                        <h3 class="text-uppercase">Itemgroepen</h3>

                    </div>
                    <div class="col-6">
                        <i class="fa fa-plus float-right " data-toggle="modal" data-target="#newItemgroup"
                           style="font-size: 24px;cursor: pointer"></i>
                    </div>




                </div>
            </div>-->
        </div>
        <!-- Modal -->
      <!--  <div class="modal fade" id="newItemgroup" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "itemgroups",
    }
</script>

<style scoped>
    .card {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
        padding: 0;
        border: unset;
    }

    .no-gutters {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
    }

    .card-footer {
        border-top: unset;
    }
    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;
        margin-top: 10px;
        opacity: 1;
    }

    .flex-body {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
    }

    .item {
        flex: 1 1 18%;
        height: auto;
        margin: 4px;
        margin-right: 10px;
        padding: 10px 0;
        width: auto;
    }
    .search-box {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border: 1px solid #292929;
        border-radius: 4px;
        height: 40px;
        width: 20rem;
    }

    .search-btn {
        background: transparent;
        border: unset;
        margin-left: -30px;

        -webkit-appearance: none;
    }
</style>
